import React, { useEffect } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function ProtectedRoute({ children }) {
  const { isAuthenticated, ensureSession } = useAuth();

  // The single trigger for the init bootstrap: every authenticated screen
  // renders through here, so a login (which clears the stored session) or a
  // fresh/cleared browser gets exactly one init, and every later navigation
  // runs off localStorage. Not awaited — no screen blocks on it, and the
  // catch keeps a failed bootstrap from surfacing as an unhandled rejection
  // (ensureSession clears its in-flight ref, so the next mount retries).
  useEffect(() => {
    if (isAuthenticated) ensureSession().catch(() => {});
  }, [isAuthenticated, ensureSession]);

  if (!isAuthenticated) return <Navigate to="/login" replace />;
  return children;
}
